document.addEventListener('DOMContentLoaded', function () {
  // Variables
  const sections = document.getElementsByClassName('content-tabs')
  // Initializing Items
  for (let i = 0; i < sections.length; i++) {
    // Variables
    const section = sections[i]
    const tabs = document.querySelectorAll('[role="tab"]')
    const tabList = document.querySelector('[role="tablist"]')
    let tabFocus = 0
    const contentTabWrapper = section.querySelector('.content-tabs__content-wrapper')

    function loadGrid (id) {
      contentTabWrapper.classList.add('content-tabs__content-wrapper--fade-out')
      const activeWrapper = section.querySelector('.content-tabs__content-wrapper--active')
      const newActive = section.querySelector('#' + id)
      setTimeout(() => {
        activeWrapper.classList.remove('content-tabs__content-wrapper--active')
        newActive.classList.add('content-tabs__content-wrapper--active')

        contentTabWrapper.classList.remove('content-tabs__content-wrapper--fade-out')
        contentTabWrapper.classList.add('content-tabs__content-wrapper--fade-in')

        setTimeout(() => {
          contentTabWrapper.classList.remove('content-tabs__content-wrapper--fade-in')
        }, 250)
      }, 250)
    }

    tabs.forEach((tab) => {
      tab.addEventListener("click", function() {
        if (!tab.classList.contains('active')) {
          const activeButton = section.querySelector('button.active')

          loadGrid(tab.dataset.controls)
          tab.classList.add('active')
          activeButton.classList.remove('active')
        }
      })
    })

    tabList.addEventListener("keydown", (e) => {
      if (e.key === "ArrowRight" || e.key === "ArrowLeft") {
        tabs[tabFocus].setAttribute("tabindex", -1)
        if (e.key === "ArrowRight") {
          tabFocus++
          if (tabFocus >= tabs.length) {
            tabFocus = 0
          }
        } else if (e.key === "ArrowLeft") {
          tabFocus--
          if (tabFocus < 0) {
            tabFocus = tabs.length - 1
          }
        }
  
        tabs[tabFocus].setAttribute("tabindex", 0)
        tabs[tabFocus].focus()
      }
    })
  }
})
